import script from "./CustomDashboardVerticalView.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDashboardVerticalView.vue?vue&type=script&setup=true&lang=js"

import "./CustomDashboardVerticalView.vue?vue&type=style&index=0&id=49c8052b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c8052b"]])

export default __exports__